import React from 'react';
import { getStyle } from '../../components';
import { PropTypes } from 'prop-types';
import autobind from 'autobind-decorator';
import { SecondKillComp } from '..';
import { dateformat } from '../../utils';
import './AppListList.less';



/**
 * 商品列表 - 左图右文版
 * @class AppListList
 * @extends {React.Component<any, any>}
 */
class AppListList extends React.Component<any, any> {
    static defaultProps = {
        prefixCls: 'app-list'
    };

    dataType: any = {
        '11': '开始秒杀',
        '12': '开始抢购',
        '21': '结束秒杀',
        '22': '结束抢购'
    };

    // Refs
    private videoRef: HTMLVideoElement | null = null;

    constructor(props) {
        super(props);
        this.state = {
            isPlaying: false,
            isWifi: true
        };
    }

    componentDidMount() {
        // 检测网络类型
        this.checkNetworkType();
    }

    componentWillUnmount() {
        // 停止视频播放
        if (this.videoRef) {
            this.videoRef.pause();
        }
    }

    // 检测网络类型
    private checkNetworkType = () => {
        const connection = (navigator.connection || navigator.mozConnection || navigator.webkitConnection) as Navigator['connection'];
        let isWifi = true;
        if (connection) {
        const type = (connection.type || '').toLowerCase();
        console.log('****打印网络类型****')
        console.log(type)
        // 改进的判断逻辑：桌面浏览器默认按WiFi处理
        isWifi = ['wifi', 'ethernet', 'wlan'].indexOf(type) !== -1;
        if(['wifi', 'ethernet', 'wlan'].indexOf(type) !== -1){
            //属于wifi,有线网络,默认进行播放，其它情况默认蜂窝数据
            isWifi = true;
        }else{
            isWifi = false;
        }
        console.log('当前网络是否为WIFI：' + isWifi)
        // 如果在桌面环境且检测到移动网络类型，默认按WiFi处理（因为桌面通常是有线/WiFi）
        // const networkType = (connection.effectiveType || '').toLowerCase();
        // if (!isWifi && (networkType === '4g' || networkType === '3g' || networkType === '2g')) {
        //   console.log('当前网络发现是桌面环境，默认按WIFI网络进行')
        //   console.log(networkType)
        //   isWifi = true;
        // }
        }
        
        // 设置状态，并在是WiFi时触发自动播放
        this.setState({ isWifi }, () => {
            const { data } = this.props;
            if (data.video && isWifi) {
                this.playVideo();
            }
        });
    };



    // 播放视频（静音）
    private playVideo = () => {
        if (this.videoRef && !this.state.isPlaying) {
            this.videoRef.play().then(() => {
                this.setState({ isPlaying: true });
            }).catch(err => {
                console.log('自动播放失败:', err);
                this.setState({ isPlaying: false });
            });
        }
    };

    // 显示的活动文字
    @autobind
    private _showText(promotStatus: any, type: any): any {
        const typeStr: string = `${promotStatus}${type}`;
        return this.dataType[typeStr];
    }

    // 跳转商品详情
    @autobind
    toAppDetail(data, e) {
        // 修复购物车图标的 className 选择器（原代码少了短横线）
        if (e.target.className !== `${this.props.prefixCls}add_car_icon` && 
            e.target.className !== `${this.props.prefixCls}add_car_icon-s`) {
            if (this.props.toApptaile) {
                this.props.toApptaile(data.productId, data.skuCode, e);
            }
        }
    }

    // 跳转到视频详情页
    @autobind
    goToVideoDetail(data, e) {
        e.stopPropagation();
        const { shopHomeJia, toApptaile } = this.props;
        
        // 存储数据到 sessionStorage，防止返回时数据丢失
        sessionStorage.setItem('videoDetailData', JSON.stringify({
            data: data,
            shopHomeJia: shopHomeJia,
            toApptaile: toApptaile
        }));
        
        if (this.context.router) {
            this.context.router.history.push({
                pathname: '/videoDetail',
                state: {
                    data: data,
                    shopHomeJia: shopHomeJia,
                    toApptaile: toApptaile
                }
            });
        }
    }

    render() {
        const {prefixCls, data, shopHomeJia, isApp, shareProc, isSpecial, date, promotStatus, type} = this.props;
        let style = getStyle(this.props);
        let isBClass = isApp ? '-b' : '';
        
        // 判定是否售罄
        const isSoldOut = isSpecial ? (data.status === -1) : (data.status === 11);
        
        // 视频相关
        const { isPlaying, isWifi } = this.state;
        const hasVideo = !!data.video;

        return (
            <div 
                className={`${prefixCls}-container ${isBClass}`} 
                style={style}
            >
                {/* 左侧图片区域 (包含标签、主图/视频、秒杀、售罄) */}
                <div className={`${prefixCls}-left`}>
                    {/* 标签 */}
                    <div className={`${prefixCls}label-box`}>
                        {data.labelImgList && data.labelImgList.map((item, index) => (
                            <img src={item} key={index} alt="标签" />
                        ))}
                    </div>
                    
                    {/* 主图/视频容器 */}
                    <div 
                        className={`${prefixCls}img_box cover_img_box video-container`}
                        onClick={(e) => hasVideo ? this.goToVideoDetail(data, e) : this.toAppDetail(data, e)}
                    >
                        {/* 视频元素（有视频时显示） */}
                        {hasVideo && (
                            <video
                                ref={(ref) => this.videoRef = ref}
                                src={data.video}
                                poster={data.videoCover || data.mastermap}
                                className={`product-video ${isPlaying ? 'playing' : 'paused'}`}
                                muted
                                loop
                                playsInline
                                webkit-playsinline="true"
                                preload="metadata"
                            >
                                您的浏览器不支持HTML5视频播放
                            </video>
                        )}
                        
                        {/* 无视频时显示商品主图，有视频但未播放时显示视频封面 */}
                        {!hasVideo && (
                            <img 
                                src={data.mastermap} 
                                alt={data.productName}
                                className="product-cover"
                            />
                        )}
                        {hasVideo && !isPlaying && (
                            <img 
                                src={data.videoCover || data.mastermap} 
                                alt={data.productName}
                                className="product-cover"
                            />
                        )}
                        
                        {/* 非WiFi提示（有视频但未播放时显示） */}
                        {hasVideo && !isWifi && !isPlaying && (
                            <div className="video-play-tip">
                                <div className="play-icon" />
                            </div>
                        )}
                        
                        {/* 秒杀组件 */}
                        {promotStatus !== 0 && promotStatus !== null && type !== 0 && (
                            <div className={'home-kill-box'}>
                                <SecondKillComp
                                    text={this._showText(promotStatus, type)}
                                    date={dateformat(date / 1000, 'mm月dd日 HH:MM:ss')}
                                />
                            </div>
                        )}
                        
                        {/* 售罄蒙层 */}
                        {isSoldOut && <div className={`${prefixCls}img_alerts`}>抢光了</div>}
                    </div>
                </div>

                {/* 右侧信息区域 (包含标题、广告、价格、操作按钮) */}
                <div 
                    className={`${prefixCls}-right`}
                    onClick={(e) => this.toAppDetail(data, e)}
                >
                    {/* 商品标题 */}
                    <div className={`${prefixCls}main_top${isBClass}`}>
                        {data.productAd}
                    </div>
                    
                    {/* 商品广告语 */}
                    <div className={`${prefixCls}main_middle${isBClass}`}>{data.brandsName}·{data.productName}</div>
                    
                    {/* 价格区域 (弹性布局推挤购物车图标) */}
                    <div className={`${prefixCls}-price-action`}>
                        <div className={`${prefixCls}product_price`}>
                            <span className={`${prefixCls}monye_icon`}>￥</span>
                            <span className={`${prefixCls}monye`}>{data.minPrice || data.price}</span>
                            {data.minMarkPrice && (
                                <span className={`${prefixCls}market_price`}>
                                    ￥{data.minMarkPrice || data.marketPrice}
                                    <span className={`${prefixCls}market_price_line`}/>
                                </span>
                            )}
                        </div>
                        
                        {/* 加入购物车图标 (非虚拟商品显示) */}
                        {!data.virtual && (
                            <div 
                                className={`${prefixCls}add_car_icon${isSpecial ? '-s' : ''}`}
                                onClick={(e) => {
                                    e.stopPropagation(); // 阻止冒泡触发跳转
                                    shopHomeJia(data);
                                }}
                            />
                        )}
                    </div>
                    
                    {/* 专题特有按钮 (分享赚/立即购买) */}
                    {isSpecial && (
                        <div className={`${prefixCls}-item-btn-box`}>
                            {isApp ? (
                                <div
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        shareProc(data);
                                    }}
                                    className={`${prefixCls}-share-earn`}
                                >
                                    分享赚￥{data.commission}
                                    <img src={require('../../images/share-white.png')} alt="分享" />
                                </div>
                            ) : (
                                <span>立即购买</span>
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    static contextTypes = {
        router: PropTypes.object
    };
}

export default AppListList;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/item/AppListList.tsx